<section>
  <app-breadcrumb [label]="titleBreadcrumbs"></app-breadcrumb>

  <div class="section__main section__main--commissions">
    <div class="section__title section__title--mb">
      <h1>
        Reportes
      </h1>
    </div>

    <div class="commission__block">
      <div class="commission__filter">
        <span>Filtro por fecha:</span>
        <div class="form__group">
          <div class="p-float-label">
            <p-calendar [(ngModel)]="selectedDate" (onSelect)="onChangeDate($event)" view="month" dateFormat="MM yy" [readonlyInput]="true" appendTo="body"></p-calendar>
            <label>Mes y año</label>
            <i class="pi pi-calendar fs-18"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="commission__block pt-20">
      <div class="boxCard w-full">
        <div class="boxCard__content noPad">
          <div class="commission__tabs">
            <div class="commission__tabsContent">
              <p-tabView styleClass="w-full" id="tab_reports" (activeIndexChange)="activatedTab=$event">
                <p-tabPanel>
                  <ng-template pTemplate="header">
                    <div class="tabview-header">
                      <i class="pi pi-briefcase"></i>
                      <label>Ventas</label>
                    </div>
                  </ng-template>

                  <div class="tabview-title"><h2>Ventas</h2></div>
                  <div class="tabview-content" *ngIf="activatedTab==0">
                    <app-commission-reports-sales (onLisSales)="onReceiveEvent('sales', $event)" [month]="month" [year]="year"></app-commission-reports-sales>
                  </div>
                  <div class="tabview-msg" *ngIf="onListSale.length === 0">
                    <app-custom-message-tab [messages]="messagesSale"></app-custom-message-tab>
                  </div>
                </p-tabPanel>
    
                <p-tabPanel>
                  <ng-template pTemplate="header">
                    <div class="tabview-header">
                      <i class="pi pi-money-bill"></i>
                      <label>Comisiones</label>
                    </div>
                  </ng-template>
    
                  <div class="tabview-title"><h2>Comisiones</h2></div>
                  <div class="tabview-content" *ngIf="activatedTab==1">
                    <app-commission-reports-commissions (onListCommissions)="onReceiveEvent('commissions' ,$event)" [month]="month" [year]="year"></app-commission-reports-commissions>
                  </div>
                  <div class="tabview-msg" *ngIf="onListCommissions.length === 0">
                    <app-custom-message-tab [messages]="messagesCommissions"></app-custom-message-tab>
                  </div>
                </p-tabPanel>
    
                <p-tabPanel>
                  <ng-template pTemplate="header">
                    <div class="tabview-header">
                      <i class="pi pi-wallet"></i>
                      <label>Pagos</label>
                    </div>
                  </ng-template>
    
                  <div class="tabview-title"><h2>Pagos</h2></div>
                  <div class="tabview-content" *ngIf="activatedTab==2">
                    <app-commission-reports-payments (onListPayments)="onReceiveEvent('payments' ,$event)" [month]="month" [year]="year"></app-commission-reports-payments>
                  </div> 
                  <div class="tabview-msg" *ngIf="onListPayments.length === 0">
                    <app-custom-message-tab [messages]="messagesPayments"></app-custom-message-tab>
                  </div>
                </p-tabPanel>
              </p-tabView>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
